import { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Dialog,
  makeStyles,
  Divider,
  withStyles,
  Button,
  Theme,
  createStyles,
  TextField,
  Popover
} from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import { updateUserMetrics } from '../../../store/actions/creator/creatorExperienceBuilder';
import { useDispatch } from "react-redux";
import ChipInput from 'material-ui-chip-input';

const CssChipInput = withStyles({
  chip:{
    height: 24,
    margin:"10px 5px 0px 0px"
  },
  input:{
    padding:0
  },
  chipContainer: {
   flexFlow:'row'
  },
})(ChipInput);

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
      paddingTop: 26
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    header: {
      color: '#606B76',
      fontFamily: 'Spartan-bold',
      fontSize: 24,
      paddingLeft: 17,
      paddingBottom: 7
    }
  });

const useStyles = makeStyles(() => ({
  root: {},
  paper: {
    borderRadius: '24px !important',
    overflow: 'hidden'
  },
  description: {
    color: '#697683',
    fontSize: 14,
    fontFamily: 'roboto-regular'
  },
  btn: {
    width: 80,
    height: 43,
    borderRadius: 6,
    background: '#017AEF',
    color: '#fff',
    textTransform: 'none',
    fontSize: 16,
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
  },
  th: {
    backgroundColor: '#FFE9C4',
    height: 40,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: 14,
    paddingRight: 14,
    fontFamily: 'roboto-bold',
    fontSize: 15,
    color: '#717E8B',
    borderRadius: '10px 10px 0px 0px'
  },
  td: {
    marginTop: 2,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: 14,
    paddingRight: 14,
    background: '#F0F0F0',
    fontFamily: 'roboto-regular',
    fontSize: 14,
    color: '#717E8B',
  },
  icon: {
    marginLeft: 4,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  hidden: {
    display: 'none!important'
  },
  doneBtn: {
    margin: 0,
    padding: 0,
    height: 22,
    background: '#697683',
    borderRadius: 4,
    color: '#fff',
    fontSize: 8,
    marginLeft: 5,
    '&:hover': {
      background: '#343B43'
    }
  },
  ml: {
    right: -80
  },
  icons: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
  },
  textField: {
    "& .MuiOutlinedInput-inputMarginDense": {
      margin: "0!important",
      border: '1px solid #697683',
      padding: 4,
      borderRadius: 3,
      paddingLeft: 6,
      fontSize: 14,
      color: '#717E8B',
    }
  },
  invalid: {
    color: 'red'
  },
  hover: {
    cursor: 'pointer',
    width: 16,
    height: 16,
    marginLeft: 10
  },
  transForm: {
    transform: 'rotate(180deg)'
  },
  chip:{
    overflow: 'auto hidden',
    maxWidth: 400,
    chipContainer:{
      style:{flexFlow:'row'}
    }
  },
  sortColumn: {
    display: 'flex',
    alignItems: 'center',
    width: '42%',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  },
  hoverBtnGroup: {
    width: '16%'
  },
  infoIcon: {
    width: 18,
    height: 18,
    cursor: 'pointer',
    marginTop: 1,
    marginLeft: 2
  },
  popover: {
    marginLeft: 15
  },
  popoverDiv: {
    fontFamily: 'roboto-regular',
    fontSize: 12,
    padding: 15,
    background: '#F0F0F0',
    color: '#212D40',
    maxWidth: 300,
    lineHeight: '15px'
  },
}));

const DialogTitle = withStyles(styles)((props: any) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <div className={classes.header}>{children}</div>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon style={{ fontSize: 30 }} />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

function CreatorInviteParticipantModal({ open, onClose, data, errorEmailIndex, ...rest }: any) {

  const classes = useStyles();
  const [editIndex, setEditIndex] = useState(-1);
  const [initStepHover, setInitStepHover] = useState(-1);
  const [emailSort, setEmailSort] = useState(false);
  const [tagSort, setTagSort] = useState(false);
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const openPopover = Boolean(anchorEl);
  const id = openPopover ? 'simple-popover' : undefined;

  const removeItem = (index: number) => {
    const old = [...data];
    old.splice(index, 1);
    onSaveParticipants(old);
  };

  const setOnChangeTitle = (e: any, index: number) => {
    const old = [...data];
    old[index].email = e.target.value;
    onSaveParticipants(old);
  };

  const onSaveParticipants = (data: any) => {
    dispatch(updateUserMetrics('asyncParticipants', data))
  };

  const handleSort = (type: string) => {
    setEditIndex(-1);
    let sortedData = [...data];
    if (type === 'email') {
      setEmailSort(!emailSort);
      sortedData = emailSort ?
        data.sort((a: any, b: any) => {
          if (a.email > b.email) { return 1; }
          if (a.email < b.email) { return -1; }
          return 0;
        })
        :
        data.sort((a: any, b: any) => {
          if (a.email < b.email) { return 1; }
          if (a.email > b.email) { return -1; }
          return 0;
        });
    } else {
      setTagSort(!tagSort);
      sortedData = tagSort ?
        data.sort((a: any, b: any) => {
          if (a.tags > b.tags) { return 1; }
          if (a.tags < b.tags) { return -1; }
          return 0;
        })
        :
        data.sort((a: any, b: any) => {
          if (a.tags < b.tags) { return 1; }
          if (a.tags > b.tags) { return -1; }
          return 0;
        });
    }
    dispatch(updateUserMetrics('asyncParticipants', sortedData))
  };

  const handleBeforeAddEmail = (value: string,index:any) => {
    const addNew = [...data];
    const array = addNew[index].tags !== "" ? addNew[index].tags.split(","):[];
    array.indexOf(value) === -1 && array.push(value);
    addNew[index].tags = array.join(", ");
    dispatch(updateUserMetrics('asyncParticipants', addNew))
  };

  const handleDeleteEmail = (email: string, index: number) => { 
    const addNew = [...data];
    const array = addNew[index].tags !== "" ? addNew[index].tags.split(",") : [];
    const tagindex = array.indexOf(email);
    if (tagindex !== -1) {
      array.splice(tagindex, 1);    
      addNew[index].tags = array.join(", ");
      dispatch(updateUserMetrics('asyncParticipants', addNew))
    } 
  };

  const onCloseDialog = () => {
    onClose();
    setEditIndex(-1);
    setInitStepHover(-1);
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth={'md'}
      onClose={onCloseDialog}
      open={open}
      classes={{
        root: classes.root,
        paper: classes.paper
      }}
    >
      <div {...rest} style={{ overflow: 'auto' }}>
        <DialogTitle onClose={onCloseDialog}>
          {data.length} Participants Added
        </DialogTitle>
        <Divider />

        <Box m={4} pl={1} pr={1}>         
          <th className={classes.th}>
            <td className={classes.sortColumn}>
              Email
              <img src='/assets/icons/experiencebuilder/filter-icon.svg' alt='{}' className={clsx(classes.hover, emailSort && classes.transForm)} onClick={() => handleSort('email')} />
            </td>
            <td className={classes.sortColumn}>
              tags
              <img
                className={classes.infoIcon}
                alt="Info"
                src={'/assets/icons/info.svg'}
                onClick={(e: any) => setAnchorEl(e.currentTarget)}
              />
              <Popover
                id={id}
                open={openPopover}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'center'
                }}
                className={classes.popover}
              >
                <div className={classes.popoverDiv}>
                  Type in your tag followed by a comma to separate each tag
                </div>
              </Popover>
              <img src='/assets/icons/experiencebuilder/filter-icon.svg' alt='{}' className={clsx(classes.hover, tagSort && classes.transForm)} onClick={() => handleSort('tags')} />
            </td>
            <td className={classes.hoverBtnGroup} />
          </th>
          {
            data.map((item: any, index: number) =>
              <tr
                className={classes.td}
                key={index}
                onMouseOver={() => (editIndex === index || editIndex === -1) && setInitStepHover(index)}
                onMouseLeave={() => setInitStepHover(-1)}
              >
                <td className={classes.sortColumn}>
                  {editIndex !== index ?
                    <p className={errorEmailIndex === index ? classes.invalid : ''}>{item.email}</p>
                    :
                    <TextField
                      className={classes.textField}
                      value={item.email}
                      size="small"
                      variant="outlined"
                      onChange={(e) => setOnChangeTitle(e, index)}
                    />
                  }
                </td>
                <td className={classes.sortColumn}>
                  {editIndex !== index ?
                    <p className={errorEmailIndex === index ? classes.invalid : ''}>{item.tags}</p>
                    : <CssChipInput
                      fullWidthInput={true}
                       value={item.tags !=="" ? item.tags.split(",") : []}
                       margin='normal'
                       id="sessions"
                       InputProps={{
                         style:{flexFlow:"initial"}
                       }}
                       className={classes.chip}
                       onAdd={(email) => handleBeforeAddEmail(email,index)}
                       newChipKeyCodes={[188]}
                       newChipKeys={[]}
                       onDelete={(email) => handleDeleteEmail(email, index)}
                     />
                  }
               </td>
               <td  className={classes.hoverBtnGroup}>
                 {initStepHover !== index && <div style={{marginLeft: 56}} />}
                 <div className={clsx(classes.icons, initStepHover !== index && classes.hidden, editIndex !== index && classes.ml)}>
                   <img src={'/assets/icons/experiencebuilder/edit-icon.svg'} alt="{}" className={classes.icon} onClick={() => setEditIndex(index)} />
                   <img src={'/assets/icons/experiencebuilder/trash-icon.svg'} alt="{}" className={classes.icon} onClick={() => removeItem(index)} />
                   {editIndex === index && <Button className={classes.doneBtn} onClick={() => setEditIndex(-1)}>DONE</Button>}
                 </div>
               </td>
              </tr>)
          }
        </Box>
        <Box mt={3} mb={3} mr={2} display='flex' justifyContent='flex-end'>
          <Button onClick={onCloseDialog} color='primary' size='large' className={classes.btn}>
            OK
          </Button>
        </Box>
      </div>
    </Dialog>
  );
}

CreatorInviteParticipantModal.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  data: PropTypes.any,
  errorEmailIndex: PropTypes.number
};

CreatorInviteParticipantModal.defaultProps = {
  onClose: () => { }
};

export default CreatorInviteParticipantModal;
